import { Box } from "@mui/material";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";
import { useEffect, useState } from "react";

const SubSection = ({ isFrom, descRef, question }) => {
  const [desc, setDesc] = useState(question?.description || "");

  useEffect(() => {
    setDesc(question?.description || "");
  }, [question]);

  const handleChange = ({ name, value }) => {
    setDesc(value);
    descRef.current = value;
  };

  const isDisabled = isFrom !== "surveyCreation";

  return (
    <Box
      sx={{
        pointerEvents: isFrom === "publishedSurvey" ? "none" : "auto",
      }}
    >
      <AdvancedInputField
        name="desc"
        data={desc}
        placeholder="Enter section description..."
        disabled={isDisabled}
        handleChange={handleChange}
      />
    </Box>
  );
};

export default SubSection;
